import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import { APP_CONFIG } from './const/config.const'
import { TOPUP_CONFIG } from './const/topup.const'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.prototype.$VUE_APP_OPERATOR = APP_CONFIG.OPERATOR
Vue.prototype.$VUE_APP_CONFIG = APP_CONFIG[process.env.NODE_ENV]
Vue.prototype.$VUE_TOPUP_CONFIG = TOPUP_CONFIG

new Vue({
  render: h => h(App)
}).$mount('#app')
